module.exports = "https://www.gc-pro.gnp.com.mx/51a8e3ee72eb92aa511e8475b216f2a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/boton/04.png
// module id = 1009
// module chunks = 0 1